/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';
import { DocumentValueType, MemberPhoneType } from '../Types/CommonTypes';

// Dados de entrada da API
export type ResetPasswordAccountIssueRequestType = {
  email?: string;
  memberNumber?: string;
  document?: DocumentValueType;
  formPage: {
    name: string;
    email?: string;
    memberNumber?: string;
    document?: DocumentValueType;
    phoneList: MemberPhoneType[];
  };
};

const definitions = Definitions.ResetPasswordAccountIssue;

const callPost = async (
  params: ResetPasswordAccountIssueRequestType,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };
export default { call, definitions };
